import { render, staticRenderFns } from "./menuDetailThree.vue?vue&type=template&id=234efa6d&scoped=true&"
import script from "./menuDetailThree.vue?vue&type=script&lang=js&"
export * from "./menuDetailThree.vue?vue&type=script&lang=js&"
import style0 from "./menuDetailThree.vue?vue&type=style&index=0&id=234efa6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234efa6d",
  null
  
)

export default component.exports